import script from "./DashboardIcon.vue?vue&type=script&setup=true&lang=js"
export * from "./DashboardIcon.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__